"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("color"));
var themeColors = {
    primaryColor: (0, color_1.default)('#061638'),
    textSecondary: (0, color_1.default)('#FFFFFF'),
    textPrimaryColor: (0, color_1.default)('#0D1B23'),
    secondaryColor: (0, color_1.default)('#EF9D07'),
    textSecondaryColor: (0, color_1.default)('#637179'),
    warningColor: (0, color_1.default)('#A63900'),
    dangerColor: (0, color_1.default)('#b60037'),
    errorLightColor: (0, color_1.default)('#ffcedd'),
    successColor: (0, color_1.default)('#006F0A'),
    infoColor: (0, color_1.default)('#0061B2'),
    roseColor: (0, color_1.default)('#E91E63'),
    grayColor: (0, color_1.default)('#637179'),
    white: (0, color_1.default)('#FFFFFF'),
    black: (0, color_1.default)('#070E11'),
    background: (0, color_1.default)('#eff3f5'),
    divider: (0, color_1.default)('#CDE8EA'),
    focusOutlineColor: (0, color_1.default)('#101D31'),
    warningBackgroundColor: (0, color_1.default)('#ffd7e3'),
    warningTextColor: (0, color_1.default)('#0d1b23'),
    cornerColors: {
        activity: (0, color_1.default)('#008996'),
        activityContrast: (0, color_1.default)('#FFFFFF'),
        reward: (0, color_1.default)('#008996'),
        rewardContrast: (0, color_1.default)('#000000'),
        promotion: (0, color_1.default)('#FFFFFF'),
        promotionContrast: (0, color_1.default)('#008996'),
        game: (0, color_1.default)('#008996'),
        gameContrast: (0, color_1.default)('#FFFFFF')
    },
    poll: {
        selected: (0, color_1.default)('#999999'),
        first: (0, color_1.default)('#3851af'),
        second: (0, color_1.default)('#99cc33'),
        third: (0, color_1.default)('#ff9933'),
        fourth: (0, color_1.default)('#7D98FE')
    }
};
exports.default = themeColors;
//# sourceMappingURL=colors.js.map